export enum RELEASE_TYPE {
  FEATURE = 'FEATURE',
  RELEASE_NOTES = 'RELEASE_NOTES',
}
